import { BookmarkEntry, IBookmark, IBookmarkFolder, BookmarkModule } from "@/modules/BookMarkModule";
import { Store } from "@/store";
import { EquatorialCoord } from "@hscmap/angle";
import * as easing from '@hscmap/easing';
import { Animation, Globe } from "@hscmap/stellar-globe";

// tslint:disable-next-line
export async function walkBookmarks(folder: IBookmarkFolder, Store: Store, module: BookmarkModule) {
  module.walking = true

  const config = Store.modules.bookmark.config.walk

  const globe = Store.currentGlobe()
  const vf = globe.viewFactory

  let animation: Animation

  const off = module.$watch('walking', () => {
    animation.abort()
  })

  const P = (a: Animation) => {
    animation = a
    return a.promise
  }

  await P(sleep2(1000, globe))
  try {
    const bs = childBookmarks(folder)
    do {
      if (bs.length === 0) {
        break
      }
      for (const b of bs) {
        const { view } = b
        const { a, d, fovy, roll } = view
        const coord = EquatorialCoord.fromRad(a, d)
        const { duration, keepFovy } = config
        const easingFunction = easing[config.easing]
        await P(vf.jumpTo({ fovy, roll }, { coord, duration, keepFovy, easingFunction }))
        await P(sleep2(config.wait, globe))
      }
    } while (config.loop)
  } finally {
    off()
    vf.jumpTo({ roll: 0 })
  }
}

function sleep2(t: number, globe: Globe) {
  return globe.animation(({ }) => {
  }, { duration: t })
}

function childBookmarks(root: IBookmarkFolder) {
  const bs: IBookmark[] = []
  const dig = (f: BookmarkEntry) => {
    if (f.isFolder) {
      for (const c of f.children) {
        dig(c)
      }
    } else {
      bs.push(f)
    }
  }
  dig(root)
  return bs
}
